// 전시 상태
export default Object.freeze({
  STATUS: '노출 플랫폼',

  ALL: '전체',
  PC: 'PC 웹',
  MOBILE_WEB: '모바일 웹',
  MOBILE_APP: '모바일 앱',
});
